import { render, staticRenderFns } from "./ProductTable.vue?vue&type=template&id=d3f99bf6&scoped=true&"
import script from "./ProductTable.vue?vue&type=script&lang=js&"
export * from "./ProductTable.vue?vue&type=script&lang=js&"
import style0 from "./ProductTable.vue?vue&type=style&index=0&id=d3f99bf6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3f99bf6",
  null
  
)

export default component.exports